<template>
  <div class="form-group no-gutters row">
    <div class="col-sm-4">
      <select class="form-control" @change="change" v-model="dayValue" :disabled="disabled" required>
        <option value="" disabled>Day</option>
        <option :value="day" v-for="day in days" :key="day">{{day}}</option>
      </select>
      <div class="invalid-feedback">Day is required.</div>
    </div>
    <div class="col-sm-4">
      <select class="form-control" @change="change" v-model="monthValue" :disabled="disabled" required>
        <option value="" disabled>Month</option>
        <option :value="key" v-for="(month, key) in months" :key="key">{{month}}</option>
      </select>
      <div class="invalid-feedback">Month is required.</div>
    </div>
    <div class="col-sm-4">
      <select class="form-control" @change="change" v-model="yearValue" :disabled="disabled" required>
        <option value="" disabled>Year</option>
        <option :value="year" v-for="year in years" :key="year">{{year}}</option>
      </select>
      <div class="invalid-feedback">Year is required.</div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      days () {
        const maxDay = this.year && this.month ? new Date(this.year, this.month + 1, 0).getDate() : 31
        return Array.from(Array(maxDay).keys()).map(i => i + 1)
      },
      dayValue: {
        get () {
          return isNaN(this.day) ? '' : this.day
        },
        set (newVal) {
          this.day = newVal
        }
      },
      monthValue: {
        get () {
          return isNaN(this.month) ? '' : this.month
        },
        set (newVal) {
          this.month = newVal
        }
      },
      yearValue: {
        get () {
          return isNaN(this.year) ? '' : this.year
        },
        set (newVal) {
          this.year = newVal
        }
      }
    },
    data () {
      return {
        day: this.value ? this.value.getDate() : NaN,
        month: this.value ? this.value.getMonth() : this.initMonth - 1,
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        year: this.value ? this.value.getFullYear() : this.initYear,
        years: []
      }
    },
    methods: {
      change () {
        this.$emit('change')
        this.$emit('input', new Date(this.year, this.month, this.day))
      }
    },
    mounted () {
      const currentYear = new Date().getFullYear()
      const maxYear = currentYear - this.maxYear
      const minYear = currentYear - this.minYear
      for (let i = maxYear; i >= minYear; i--) {
        this.years.push(i)
      }
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      initMonth: {
        type: Number,
        default: NaN
      },
      initYear: {
        type: Number,
        default: NaN
      },
      minYear: {
        type: Number,
        default: 110
      },
      maxYear: {
        type: Number,
        default: 18
      },
      value: Date
    },
    watch: {
      initMonth (newMonth) {
        this.month = newMonth - 1
      },
      initYear (newYear) {
        this.year = newYear
      },
      value (newDate) {
        if (newDate) {
          const valid = !isNaN(newDate.getFullYear())
          if (valid) {
            this.day = newDate.getDate()
            this.month = newDate.getMonth()
            this.year = newDate.getFullYear()
          }
        } else {
          this.day = NaN
          this.month = NaN
          this.year = NaN
        }
      }
    }
  }
</script>

<style scoped>
</style>
